import { render, staticRenderFns } from "./ouoeItem.vue?vue&type=template&id=77f25973&lang=pug&"
import script from "./ouoeItem.vue?vue&type=script&lang=js&"
export * from "./ouoeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports